// このファイルを消してからmake driversすると生成し直しますが、ファイルがあれば上書きはされません。

import {initProcess} from './initProcess';
import {tableInit, flushTables} from './tables';

// TODO: プロジェクトごとに、必要な機能をimportする
import zettant from '@/boot/zettant-init';
import sentry from '@/boot/sentry-init';

const appInit = (app: any) => {
  // TODO: importした機能を初期化する
  // cognito環境のない状態での動作確認のため、一時的にコメントアウトする
  zettant({app});
  sentry({app});
};

export default {initProcess, tableInit, flushTables};
export {initProcess, tableInit, flushTables, appInit};
